import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as classNames from 'classnames';
import Upsell from './upsell';
import UrlHelpers from '../shared/url_helpers';
import { UserStore, Tracker, APIRequest } from '@reverbdotcom/discovery-ui';

const VIEW_TYPE = 'upsells';
const AID = 'related_content_upsells';

class Upsells extends React.Component {
  constructor() {
    super();

    this.state = {
      loaded: false,
      upsells: [],
    };
  }

  componentDidMount() {
    this.fetchUpsells();
  }

  fetchUpsells() {
    APIRequest.V3.get(
      UrlHelpers.listingUpsellsPath(this.props.listingId),
      { include_grid_images: true },
    ).then((response) => {
      this.setState({ upsells: response.upsells, loaded: true });
      this.trackUpsells(response.upsells);
    });
  }

  trackUpsells(upsells) {
    if (!upsells.length) { return null; }

    Tracker.view({
      name: VIEW_TYPE,
      type: 'listings',
      ids: upsells.map(l => l.id),
    });
  }

  upsells(upsellCollection) {
    const upsells = upsellCollection || this.state.upsells;
    if (upsells.length >= 4) {
      return upsells.slice(0, 4);
    }
    return upsells;
  }

  get hasUpsells() {
    return this.upsells().length;
  }

  get aid() {
    return this.props.aid ? this.props.aid : AID;
  }

  renderUpsell(upsell, idx) {
    return (
      <Upsell
        upsell={upsell}
        key={upsell.id}
        aid={this.aid}
        renderForSidebar={this.props.renderForSidebar}
        index={idx}
        addToCartButton={this.props.addToCartButton}
      />
    );
  }

  renderUpsells() {
    if (this.props.renderForSidebar) {
      return (
        <ul>
          {this.upsells().map((u, i) => this.renderUpsell(u, i))}
        </ul>
      );
    }

    return (
      <ul className="g-container g-container--cycle">
        {this.upsells().map((u, i) => (
          <li
            className="g-col-3 g-col-mobile-6"
            key={i}
          >
            {this.renderUpsell(u, i)}
          </li>
        ))}
      </ul>
    );
  }

  renderPlaceholder() {
    return (
      <div className="product-card product-card--placeholder">
        <div className="product-card-img-container" />
        <div className="product-card-description">
          <div className="product-card-body-sized" />
        </div>
      </div>
    );
  }

  renderPlaceholders() {
    if (this.props.renderForSidebar) { return null; }

    return (
      <ul className="g-container g-container--cycle">
        <li className="g-col-3 g-col-mobile-6">
          {this.renderPlaceholder()}
        </li>
        <li className="g-col-3 g-col-mobile-6">
          {this.renderPlaceholder()}
        </li>
        <li className="g-col-3 g-col-mobile-6">
          {this.renderPlaceholder()}
        </li>
        <li className="g-col-3 g-col-mobile-6">
          {this.renderPlaceholder()}
        </li>
      </ul>
    );
  }

  render() {
    if (!this.state.loaded) { return this.renderPlaceholders(); }
    if (!this.hasUpsells) { return null; }

    return (
      <div>
        <h4 className="weight-bold mb-1">
          {I18n.t('productShowPage.recommends')}
        </h4>
        {this.renderUpsells()}
      </div>
    );
  }
}

Upsells.propTypes = {
  addToCartButton: PropTypes.any.isRequired,
  listingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  aid: PropTypes.string,
  renderForSidebar: PropTypes.bool,
};

Upsells.defaultProps = {
  renderForSidebar: false,
};

export default Upsells;



// WEBPACK FOOTER //
// ./javascripts/components/product_show_page/upsells.jsx